import { ResetPasswordComponent } from 'app/components/reset-password/reset-password.component';
import { Route } from '@angular/router';

export const resetPasswordRoute: Route = {
  path: 'reset-password',
  component: ResetPasswordComponent,
  data: { title: 'Установка пароля' }
};
